import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
    AcceptedProviders,
    configDataTrackerEvent,
    type DefaultData,
    type ILimits,
    type ITrackerConfig,
} from '@signaturit/data-tracker-client';

import { ActiveProduct } from '../../../models/ActiveProduct';
import { selectUserInfo } from '../../store/User/reducer';
import { selectActiveProducts } from '../../store/Products/reducer';

const DATA_TRACKER_URL = `${process.env.DATA_TRACKER_URL}` || '';
const DATA_TRACKER_KEY = `${process.env.DATA_TRACKER_KEY}` || '';
const DATA_TRACKER_MIXPANEL_KEY = `${process.env.DATA_TRACKER_MIXPANEL_KEY}` || '';

export const DataTrackerClientConfigurator = () => {
    const user = useSelector(selectUserInfo);
    const products: ActiveProduct[] | undefined = useSelector(selectActiveProducts);

    const getConfiguredProviders = (): ITrackerConfig[] => {
        const trackerProviders: ITrackerConfig[] = [];

        if (DATA_TRACKER_MIXPANEL_KEY) {
            trackerProviders.push({
                provider: AcceptedProviders.mixpanel,
                apiKey: DATA_TRACKER_MIXPANEL_KEY,
            });
        }

        if (DATA_TRACKER_KEY && DATA_TRACKER_URL) {
            trackerProviders.push({
                provider: AcceptedProviders.signaturit,
                apiKey: DATA_TRACKER_KEY,
                providerUrl: DATA_TRACKER_URL,
            });
        }

        return trackerProviders;
    };

    useEffect(() => {
        const userId = user?.userId;
        const accountId = user?.accountId;
        const email = user?.email;
        const license = user?.codename;
        const hasAllData = products && userId && accountId && email;

        if (hasAllData) {
            const providers = getConfiguredProviders();
            const limits: ILimits = {};

            products?.forEach((product: ActiveProduct) => {
                limits[product.type] = product.quantity;
            });

            const eventsConfig: DefaultData = {
                userId,
                accountId,
                email,
                limits,
                license,
            };

            configDataTrackerEvent(providers, eventsConfig);
        }
    }, [user, products]);

    return null;
};
